import * as Sentry from '@sentry/react';

export const initializeSentry = () => {
  Sentry.init({
    environment: process.env.NODE_ENV,
    dsn: import.meta.env.VITE_SENTRY_DSN_URL || import.meta.env.REACT_APP_SENTRY_DSN_URL,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.captureConsoleIntegration({
        levels: ['debug'],
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    debug: false,
  });
};
